define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/_base",
	"csi/locale",
	"csi/xml",
	"csi/xml/ExtractQuery",
	"./Values"
], function(declare,_,csiHeading,locale,xml,ExtractQuery,Values) {

	var _COUNT = "__Count__";

	var _ExtractValues = declare(Values, {
		// same as Extract store
		queryClass: ExtractQuery,
		requestBinaryParameter: "XMLFilter",
		requestModule: "SiteAdmin",
		requestOperation: "AggregateExtractStore",
		requestOmitParameters: null,

		_getData: function(/*Response*/res) {
			// summary: convert response values/nodes into store items
			var ctx = this.ctx;
			var spec = this.spec;
			var columns = res.data.CUBE.Columns;
			var data = res.data.CUBE.Data;
			var dataNames = res.data.Names;
			var countIndex = _.indexOf(columns, _COUNT);
			var valueIndex = (countIndex == 0) ? 1 : 0;
			var blankValue = spec.ra.getBlankValue();

			return _.map(data, function(row) {
				var value = row[valueIndex];
				var text;

				if (value === blankValue) {
					text = locale.resource(xml.VALUE_BLANK);
				} else if (spec.type == xml.ATTR_REF) {
					text = dataNames[value] || locale.getEmptyName();
				} else {
					text = csiHeading.getTextForFilterValue(ctx, spec, value);
				}

				return {
					_count: row[countIndex] || 1,
					_text: text,
					_value: value
				};
			});
		},
	
		_onResponse: function(/*Response*/res, /*Request*/req, /*Object*/options) {
			// summary: extract data from response and populate store
			this._onData(this._getData(res), options);
		},

		_sortData: function(/*Object[]*/data) {
			// summary: sort values by field "data._text" (see _getData() above)
			return _.sortBy(data, function(item){
				return item._text;
			});
		}
	});

	_ExtractValues.METRIC_COUNT = _COUNT;

	return _ExtractValues;
});